export enum ExchangeListTabsEnum {
  // PENDING = 'pending',
  DRAFT = 'draft',
  OPEN = 'open',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  DELETED = 'deleted'
}
